import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { getHTML } from '../../../services/commonFunction';
import ZoomInIcon from '../../../assets/icons/ZoomInIcon';

function ProductCard({data, onOpen=()=>{}}) {

  return (
    <div className='relative group shadow-hover-parent cursor-pointer  transition-all duration-[0.5s]'>
        <div className='w-full h-[400px] max-[1800px]:h-[350px] max-[1400px]:h-[300px] shadow-hover-child  rounded-[0px] overflow-hidden relative'>
          <img className='w-full h-full rounded-[0px] group-hover:scale-[1.2] transition-all duration-[0.5s]' src={data?.image_full_url} />
          <div onClick={()=>onOpen()} className='w-full h-full bg-black/30 absolute top-0 left-0 flex items-center justify-center'>
            <button className='hidden group-hover:inline-block' onClick={()=>onOpen()}>
              <ZoomInIcon />
            </button>
          </div>
        </div>
        <div className='mt-[15px] '>
            <h3 className='text-[--red] text-[24px] font-[700]'>{data?.translate?.title}</h3>
          </div>
    </div>
  )
 }

export default ProductCard